import React, { useRef, useState, useEffect } from 'react';
import { Box } from "@mui/material";
import { TVChartContainer } from '../../components/TVChartContainer/usdclp';
import './usdclp.css'

const Atr = () => {
  const widgetRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {};

    const handleFullScreenChange = () => {
      if (document.fullscreenElement) {
        setIsFullScreen(true);
      } else {
        setIsFullScreen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
  }, []);

  const rotationStyles = isFullScreen 
    ? { transform: "rotate(-90deg)", width: "100vh", height: "100vw", overflow: "scroll", position: "absolute", top: "100%", left: "0" } 
    : {};
  const fullScreenStyles = isFullScreen
    ? { width: '100%', height: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1000, margin: 0, padding: 0 }
    : {};

  return (
    <Box className='USDCLP' m="20px" height="60%">
      <div ref={widgetRef} style={{ ...rotationStyles, ...fullScreenStyles }}>
        <TVChartContainer />
      </div>
    </Box>
  );
};

export default Atr;